import { FamilyRelationshipEnum } from "../../Types/Enums/HereditaryRelationshipEnum";

export const FAMILY_RELATIONSHIP_MAP = [
  // Direct
  { id: FamilyRelationshipEnum.MOTHER, labels: { 0: "Madre", 1: "Mother" } },
  { id: FamilyRelationshipEnum.FATHER, labels: { 0: "Padre", 1: "Father" } },
  { id: FamilyRelationshipEnum.BROTHER, labels: { 0: "Hermano", 1: "Brother" } },
  { id: FamilyRelationshipEnum.SISTER, labels: { 0: "Hermana", 1: "Sister" } },

  // Grandparents
  { id: FamilyRelationshipEnum.MATERNAL_GRANDMOTHER, labels: { 0: "Abuela Materna", 1: "Maternal Grandmother" } },
  { id: FamilyRelationshipEnum.MATERNAL_GRANDFATHER, labels: { 0: "Abuelo Materno", 1: "Maternal Grandfather" } },
  { id: FamilyRelationshipEnum.PATERNAL_GRANDMOTHER, labels: { 0: "Abuela Paterna", 1: "Paternal Grandmother" } },
  { id: FamilyRelationshipEnum.PATERNAL_GRANDFATHER, labels: { 0: "Abuelo Paterno", 1: "Paternal Grandfather" } },

  // Aunts & Uncles
  { id: FamilyRelationshipEnum.MATERNAL_AUNT, labels: { 0: "Tía Materna", 1: "Maternal Aunt" } },
  { id: FamilyRelationshipEnum.MATERNAL_UNCLE, labels: { 0: "Tío Materno", 1: "Maternal Uncle" } },
  { id: FamilyRelationshipEnum.PATERNAL_AUNT, labels: { 0: "Tía Paterna", 1: "Paternal Aunt" } },
  { id: FamilyRelationshipEnum.PATERNAL_UNCLE, labels: { 0: "Tío Paterno", 1: "Paternal Uncle" } },

  { id: FamilyRelationshipEnum.OTHER, labels: { 0: "Otro Pariente", 1: "Other Relative" } },
];